export const GPC_METHODOLOGY_ID = "qype7d013uvrgpsh4550vam8";
